import AddressBookSFC from "./AddressBook.vue";
export const AddressBook = AddressBookSFC;
